export default {
  TelegramBot: {
    Fetch: 'به‌روزرسانی حساب‌ها',
  },
}
